import React from "react";
import { Phone, ArrowRight, ShieldCheck } from "lucide-react";
import { Button } from "./ui/button";
import { company, images, stats } from "../mock";

const Hero = () => {
  return (
    <section
      id="home"
      className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden"
      style={{
        background:
          "linear-gradient(160deg, #f4f9f0 0%, #eaf3fb 55%, #f7fbf4 100%)",
      }}
    >
      <div className="absolute -top-24 -right-24 h-80 w-80 rounded-full bg-[#5aa83a]/10 blur-3xl" />
      <div className="absolute -bottom-32 -left-20 h-96 w-96 rounded-full bg-[#123c74]/10 blur-3xl" />

      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="animate-in fade-in slide-in-from-left-4 duration-700">
            <span className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-semibold text-[#123c74] shadow-sm mb-6">
              <ShieldCheck className="h-4 w-4 text-[#5aa83a]" />
              Caring NDIS support, Australia wide
            </span>
            <h1 className="text-4xl sm:text-5xl lg:text-[3.4rem] font-extrabold leading-[1.08] text-[#123c74] tracking-tight">
              Support that feels
              <span className="block text-[#5aa83a]">just like family</span>
            </h1>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-xl">
              {company.name} provides warm, reliable and person-centred NDIS
              services. We help you live independently, stay connected and feel
              truly at home &mdash; every step of the way.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Button
                asChild
                className="rounded-full bg-[#5aa83a] hover:bg-[#4b9130] text-white font-semibold h-[3.25rem] px-8 text-base shadow-md hover:shadow-lg transition-all"
              >
                <a href="#enquire" className="flex items-center gap-2">
                  Enquire Today <ArrowRight className="h-4 w-4" />
                </a>
              </Button>
              <Button
                asChild
                variant="outline"
                className="rounded-full border-2 border-[#123c74] text-[#123c74] hover:bg-[#123c74] hover:text-white font-semibold h-[3.25rem] px-8 text-base"
              >
                <a href={`tel:${company.phoneRaw}`} className="flex items-center gap-2">
                  <Phone className="h-4 w-4" /> {company.phone}
                </a>
              </Button>
            </div>
          </div>

          <div className="relative animate-in fade-in slide-in-from-right-4 duration-700">
            <div className="relative rounded-[2rem] overflow-hidden shadow-2xl border-8 border-white">
              <img
                src={images.hero}
                alt="Caring support worker with participant"
                className="w-full h-[420px] md:h-[500px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-4 sm:left-6 bg-white rounded-2xl shadow-xl px-6 py-4 flex items-center gap-4 border border-slate-50">
              <div className="h-12 w-12 rounded-full bg-[#eef6e8] flex items-center justify-center">
                <ShieldCheck className="h-6 w-6 text-[#5aa83a]" />
              </div>
              <div>
                <p className="font-extrabold text-[#123c74] leading-tight">Trusted care</p>
                <p className="text-sm text-slate-500">Vetted & caring team</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-5">
          {stats.map((s) => (
            <div
              key={s.label}
              className="bg-white/70 backdrop-blur rounded-2xl p-6 text-center shadow-sm border border-white"
            >
              <div className="text-3xl font-extrabold text-[#5aa83a]">{s.value}</div>
              <div className="text-sm font-semibold text-slate-500 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
